import clsx from 'clsx';
import { HTMLAttributes } from 'react';
import Spinner from '../spinner/spinner';
import './button.scss';

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
	isLoading?: boolean;
	variant?: 'primary' | 'outline';
	danger?: boolean;
}

const Button: React.FunctionComponent<ButtonProps> = ({
	isLoading,
	variant = 'secondary',
	danger,
	children,
	...props
}) => {
	return (
		// @ts-ignore
		<button className={clsx('button', variant, { danger })} {...props} disabled={isLoading ? true : props.disabled}>
			{children}
			{isLoading && (
				<Spinner
					color="white"
					style={{
						position: 'absolute',
						right: '10px',
						top: '50%',
						transform: 'translateY(-50%)',
						width: '16px',
						height: '16px'
					}}
				/>
			)}
		</button>
	);
};

export default Button;
